import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetChatSettingsEngagementBar as GetChatSettingsEngagementBarQuery,
    ChatSettingsEngagementBarFragment,
} from 'nutshell-graphql-types';

import GET_CHAT_SETTINGS_ENGAGEMENT_BAR from '../queries/get-chat-settings-engagement-bar.graphql';

export const useGetChatSettingsEngagementBar = (): {
    chatSettings: ChatSettingsEngagementBarFragment | null | undefined;
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<any>;
} => {
    const {data, error, loading, refetch} = useQuery<
        GetChatSettingsEngagementBarQuery,
        Record<any, any>
    >(GET_CHAT_SETTINGS_ENGAGEMENT_BAR, {});

    const chatSettings = data ? data.chatSettings : null;

    return {
        chatSettings,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
